// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Roboto", sans-serif;
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #333;
}

*,
*::after,
*::before {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

p {
  margin: 0;
}

a {
  color: #434c63;
}

.container {
  max-width: 1920px;
  width: 100%;
  display: flex;
  min-height: 100vh;
}

.content-container {
  width: 77%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.content {
  margin: 2em 2em;
  min-height: 78vh;
}
.iFrame-content {
  min-height: 84vh;
}

.main-block {
  height: 70vh;
}

.teacher-name-title {
  margin-bottom: 60px;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #494a4a;
}

.group-selectors-block {
  margin-top: 25px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.group-title {
  margin-right: 80px;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #494a4a;
}

.teacher-select {
  margin-right: 30px;
  width: 330px;
}

.group-select {
  margin-right: 30px;
  width: 300px;
}

.debts-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.cart-item {
  margin-right: 10px;
  margin-bottom: 30px;
  padding: 20px 15px 20px 20px;
  width: 320px;
  border: 1px solid #b8b8b8;
  border-radius: 12px;
  box-shadow: 2px 2px 2px 1px rgb(21, 21, 54, 0.2);
  flex-grow: 1;
}

.cart-item-header {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #434c63;
}

.cart-item-row {
  margin-bottom: 10px;
}

.cart-item-row:last-child {
  margin-bottom: 0;
}

.cart-span {
  padding-right: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #8c8c8c;
}

@media screen and (max-width: 1450px) {
  .group-title {
    margin-right: 80px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 1150px) {
  .group-selectors-block {
    margin-top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .group-title {
    margin-bottom: 60px;
    margin-right: 0;
  }
}

@media screen and (max-width: 910px) {
  .group-title {
    margin-bottom: 0;
  }
}

@media screen and (max-width: 716px) {
  .teacher-select {
    margin-right: 0;
    width: 400px;
  }

  .group-select {
    margin-right: 0;
    width: 400px;
  }
}

@media screen and (max-width: 520px) {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .teacher-name-title {
    padding: 0 30px;
    text-align: center;
    margin-bottom: 0;
  }

  .group-selectors-block {
    margin-top: 0;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .group-title {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #494a4a;
  }

  .cart-item {
    margin-right: 0;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 420px) {
  .teacher-select {
    width: 320px;
  }

  .group-select {
    width: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["body {\n  font-family: \"Roboto\", sans-serif;\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #333;\n}\n\n*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n}\n\np {\n  margin: 0;\n}\n\na {\n  color: #434c63;\n}\n\n.container {\n  max-width: 1920px;\n  width: 100%;\n  display: flex;\n  min-height: 100vh;\n}\n\n.content-container {\n  width: 77%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  margin: 2em 2em;\n  min-height: 78vh;\n}\n.iFrame-content {\n  min-height: 84vh;\n}\n\n.main-block {\n  height: 70vh;\n}\n\n.teacher-name-title {\n  margin-bottom: 60px;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 30px;\n  color: #494a4a;\n}\n\n.group-selectors-block {\n  margin-top: 25px;\n  margin-bottom: 40px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.group-title {\n  margin-right: 80px;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 30px;\n  color: #494a4a;\n}\n\n.teacher-select {\n  margin-right: 30px;\n  width: 330px;\n}\n\n.group-select {\n  margin-right: 30px;\n  width: 300px;\n}\n\n.debts-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.cart-item {\n  margin-right: 10px;\n  margin-bottom: 30px;\n  padding: 20px 15px 20px 20px;\n  width: 320px;\n  border: 1px solid #b8b8b8;\n  border-radius: 12px;\n  box-shadow: 2px 2px 2px 1px rgb(21, 21, 54, 0.2);\n  flex-grow: 1;\n}\n\n.cart-item-header {\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #434c63;\n}\n\n.cart-item-row {\n  margin-bottom: 10px;\n}\n\n.cart-item-row:last-child {\n  margin-bottom: 0;\n}\n\n.cart-span {\n  padding-right: 10px;\n  font-size: 16px;\n  font-weight: 400;\n  color: #8c8c8c;\n}\n\n@media screen and (max-width: 1450px) {\n  .group-title {\n    margin-right: 80px;\n    margin-bottom: 40px;\n  }\n}\n\n@media screen and (max-width: 1150px) {\n  .group-selectors-block {\n    margin-top: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .group-title {\n    margin-bottom: 60px;\n    margin-right: 0;\n  }\n}\n\n@media screen and (max-width: 910px) {\n  .group-title {\n    margin-bottom: 0;\n  }\n}\n\n@media screen and (max-width: 716px) {\n  .teacher-select {\n    margin-right: 0;\n    width: 400px;\n  }\n\n  .group-select {\n    margin-right: 0;\n    width: 400px;\n  }\n}\n\n@media screen and (max-width: 520px) {\n  .content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .teacher-name-title {\n    padding: 0 30px;\n    text-align: center;\n    margin-bottom: 0;\n  }\n\n  .group-selectors-block {\n    margin-top: 0;\n    margin-bottom: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .group-title {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 30px;\n    color: #494a4a;\n  }\n\n  .cart-item {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .teacher-select {\n    width: 320px;\n  }\n\n  .group-select {\n    width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
